import { inject as service } from '@ember/service';
import Route from 'cio/routes/base';

export default class EnvironmentsRoute extends Route {
  @service masq;
  @service notifications;

  activate() {
    if (!this.masq.isOn) {
      this.notifications.fetch.perform();
    }
  }
}
